import type { PageConfig } from '../types';

export const yourDealershipPageConfig: PageConfig = {
  id: 'your-dealership',
  tabLabel: 'Your dealership',
  sections: [
    {
      id: 'hero',
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'unsold_leads_count', span: 'full' }],
    },
    {
      id: 'crm-hygiene',
      overline: 'CRM DATA HYGIENE',
      title: "What you're capturing at the front door",
      layout: 'grid-2',
      items: [
        { kind: 'metric', id: 'lead_capture_missing_email_rate_phone' },
        { kind: 'metric', id: 'lead_capture_missing_email_rate_walk_in' },
        { kind: 'metric', id: 'lead_capture_missing_voi_rate' },
        { kind: 'metric', id: 'unsubscribe_rate' },
      ],
    },
    {
      id: 'sales-operations',
      overline: 'SALES OPERATIONS',
      title: 'How leads convert by channel',
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'internet_conversion_rate' },
        { kind: 'metric', id: 'dealer_walk_in_conversion_rate' },
        { kind: 'metric', id: 'dealer_phone_up_conversion_rate' },
      ],
    },
    {
      id: 'sales-team',
      overline: 'SALES TEAM PERFORMANCE',
      titleFromMetric: true,
      aside: 'A coaching surface, not a leaderboard',
      action: {
        label: 'See full breakdown',
        navigation: { type: 'L2' },
      },
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'salesperson_email_capture_rate', span: 'full' }],
    },
  ],
};
